import { MakeCall } from './createMakeCall';
import { Conversation } from './types/Conversation';

export interface Payload {
  billingCountry?: string;
  paymentMethodId?: number | null;
  paymentMethodReference?: string;
  paymentType?: string;
  signature?: string;
  stripeToken?: string;
}

const createBookingRequest =
  (makeCall: MakeCall) => (conversationId: number, data: Payload) =>
    makeCall<Conversation>(
      'PUT',
      `/api/v2/conversation/${conversationId}/booking-request`,
      { data },
    );
export { createBookingRequest };
